'use strict';

angular.module('internal.users')
    .directive('internalUserNavigation', [function () {
        return {
            restrict: 'E',
            templateUrl: paths.app + 'users/components/user-navigation/user-navigation.html',
            replace: true,
            controller: ('InternalNavigation', ['$scope', 'Enterprise', function ($scope, Enterprise) {
                $scope.educationModuleOn = false;

                Enterprise.get().then(function (enterprise) {
                    if (enterprise != null) {
                        $scope.educationModuleOn = (enterprise.education_module == null ? false : enterprise.education_module);
                    }
                })
            }])
        };
    }])
;